import Tabs from "@/v2-backoffice-client/components/tabs"
import { useUserCustomerMismatchQuery } from "@/v2-backoffice-client/user/customerMismatch/user.customerMismatch.query"
import { USER_VIEW_CUSTOMER_MISMATCHES } from "@/v2-backoffice-client/user/user.constants"

// The Users page's Customer Mismatches tab trigger: how many memberships
// cross customers right now. Owns its own read of the query, which Apollo
// dedupes against the board's, so the count is live whichever tab is open
// and drops as rows are put right.
function UserCustomerMismatchTabTrigger() {
  const { data, loading } = useUserCustomerMismatchQuery()
  const count = (data?.getUserCustomerMismatches ?? []).length

  return (
    <Tabs.Trigger
      value={USER_VIEW_CUSTOMER_MISMATCHES}
      iconSrc="triangle-warning"
      isLoading={loading}
      count={count}
    >
      Customer Mismatches
    </Tabs.Trigger>
  )
}

export default UserCustomerMismatchTabTrigger
